import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;
export { BACKEND_URL };

export const tokenStore = {
  get access() {
    return localStorage.getItem("at_access");
  },
  get refresh() {
    return localStorage.getItem("at_refresh");
  },
  set({ access_token, refresh_token }) {
    if (access_token) localStorage.setItem("at_access", access_token);
    if (refresh_token) localStorage.setItem("at_refresh", refresh_token);
  },
  clear() {
    localStorage.removeItem("at_access");
    localStorage.removeItem("at_refresh");
  },
};

const api = axios.create({ baseURL: API_BASE });

api.interceptors.request.use((config) => {
  const t = tokenStore.access;
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

let refreshing = null;

api.interceptors.response.use(
  (r) => r,
  async (error) => {
    const original = error.config;
    if (error.response?.status === 401 && !original._retry && tokenStore.refresh) {
      original._retry = true;
      try {
        if (!refreshing) {
          refreshing = axios
            .post(`${API_BASE}/auth/refresh`, { refresh_token: tokenStore.refresh })
            .then((res) => {
              tokenStore.set(res.data);
              return res.data.access_token;
            })
            .finally(() => {
              refreshing = null;
            });
        }
        const newToken = await refreshing;
        original.headers.Authorization = `Bearer ${newToken}`;
        return api(original);
      } catch (e) {
        tokenStore.clear();
      }
    }
    return Promise.reject(error);
  }
);

export function apiError(e, fallback = "Something went wrong") {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  if (d?.msg) return d.msg;
  return e?.message || fallback;
}

export default api;
